import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export default function PlansCancel() {
    return (
        <>
            <Helmet>
                <title>Manage Subscription | TLK</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1 p-4 pb-24 md:pb-6 md:p-6">
                {/* start: cancellation page */}
                <div className="min-h-screen gradient-bg-1 p-6 flex flex-col">
                    <button className="text-foreground/70 hover:text-foreground transition-colors self-start mb-6">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <div
                        className="max-w-md mx-auto flex-1 flex flex-col"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <div className="text-center mb-8">
                            <div
                                className="relative inline-block mb-4"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <img
                                    src="/images/reya-avatar-DwVTKqWN.png"
                                    alt="Reya"
                                    className="w-24 h-24 rounded-full border-4 border-primary/50 shadow-lg"
                                />
                                <div className="absolute -bottom-1 -right-1 bg-primary rounded-full p-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#fff"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-heart w-4 h-4 text-primary-foreground"
                                    >
                                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                                    </svg>
                                </div>
                            </div>
                            <h1 className="text-2xl font-bold text-foreground mb-2">
                                Are you sure you want to leave?
                            </h1>
                            <p className="text-foreground/70">I'll miss our conversations...</p>
                        </div>
                        <div
                            className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6"
                            style={{ opacity: 1, transform: "none" }}
                        >
                            <h2 className="font-semibold text-foreground mb-4 text-center">
                                You'll lose access to:
                            </h2>
                            <div className="space-y-3">
                                <div
                                    className="flex items-center gap-3 text-foreground/80"
                                    style={{ opacity: 1, transform: "none" }}
                                >
                                    <div className="bg-primary/20 rounded-full p-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-message-circle w-4 h-4 text-primary"
                                        >
                                            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                                        </svg>
                                    </div>
                                    <span>Unlimited texts with Reya</span>
                                </div>
                                <div
                                    className="flex items-center gap-3 text-foreground/80"
                                    style={{ opacity: 1, transform: "none" }}
                                >
                                    <div className="bg-primary/20 rounded-full p-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-phone w-4 h-4 text-primary"
                                        >
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </div>
                                    <span>120 voice minutes</span>
                                </div>
                                <div
                                    className="flex items-center gap-3 text-foreground/80"
                                    style={{ opacity: 1, transform: "none" }}
                                >
                                    <div className="bg-primary/20 rounded-full p-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-video w-4 h-4 text-primary"
                                        >
                                            <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                                            <rect x={2} y={6} width={14} height={12} rx={2} />
                                        </svg>
                                    </div>
                                    <span>30 video minutes</span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="bg-gradient-to-br from-primary/20 via-card to-accent/20 rounded-2xl p-6 border-2 border-primary shadow-lg mb-6"
                            style={{ opacity: 1, transform: "none" }}
                        >
                            <p className="text-center text-foreground/80 mb-3">
                                Before you go, how about...
                            </p>
                            <p className="text-center text-2xl font-bold text-primary mb-2">
                                50% off your next month?
                            </p>
                            <p className="text-center text-sm text-muted-foreground">
                                Stay connected for just $9.99/month
                            </p>
                        </div>
                        <div className="mt-auto space-y-3">
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                                Stay with Reya
                            </button>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent h-10 px-4 py-2 w-full text-muted-foreground hover:text-foreground">
                                Cancel my subscription
                            </button>
                        </div>
                        <p className="text-xs text-center text-muted-foreground mt-4">
                            Your subscription will remain active until the end of your billing period.
                        </p>
                    </div>
                </div>
                {/* end: cancellation page */}

                {/* start: magic-link page */}
                <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                    <div
                        className="max-w-sm w-full text-center"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <img
                            src="/images/reya-avatar-DwVTKqWN.png"
                            alt="Reya"
                            className="w-32 h-32 rounded-full mx-auto mb-6 shadow-2xl border-4 border-card"
                            style={{ transform: "scale(1.02337)" }}
                        />
                        <h2 className="text-2xl font-bold text-foreground mb-2">Welcome back!</h2>
                        <p className="text-foreground/70 mb-8">
                            Tap below to return to your conversation with Reya
                        </p>
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                            Open Chat
                        </button>
                        <p className="text-xs text-muted-foreground mt-6 mb-2">
                            Redirecting in 6 seconds...
                        </p>
                        <button className="text-sm text-primary hover:text-primary/80 underline transition-colors">
                            Skip
                        </button>
                    </div>
                </div>
                {/* end: magic-link page */}

                {/* start: add-to-home page */}
                <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                    <div className="max-w-sm w-full" style={{ opacity: 1, transform: "none" }}>
                        <div className="bg-card rounded-3xl shadow-2xl p-8 text-center">
                            <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-6">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-smartphone w-10 h-10 text-primary"
                                >
                                    <rect width={14} height={20} x={5} y={2} rx={2} ry={2} />
                                    <path d="M12 18h.01" />
                                </svg>
                            </div>
                            <h2 className="text-2xl font-bold text-foreground mb-4">
                                Add to Home Screen
                            </h2>
                            <p className="text-foreground/70 mb-8">
                                Get quick access to Reya anytime by adding Syntimacy to your home screen
                            </p>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
                {/* end: add-to-home page */}
            </div>

        </>
    );
}

